/* PSR Trend download popup: multiselect of the contract's revenue-level CLINs (with an "All"
   option, nothing preselected) and a Download button that stays disabled until at least one CLIN is chosen. */
import React, { useEffect, useState } from "react";
import { Dialog, DialogContent } from "@material-ui/core";
import { Select } from "antd";
import { getRvnLvlClinListAPI } from "../../../api/financial-management-api";

const ALL = "__ALL__";
const BLUE = "#0070D2";

// Entries may be plain strings or objects; take the first recognisable CLIN field.
const clinValue = (item) =>
  typeof item === "object" && item !== null
    ? item.clin ?? item.clinId ?? item.clinLvl ?? item.value ?? item.name
    : item;

export default function PsrDownloadDialog({ open, contractId, onClose, onDownload }) {
  const [clins, setClins] = useState([]);
  const [selected, setSelected] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) return undefined;
    let cancelled = false;
    setSelected([]);
    setLoading(true);
    getRvnLvlClinListAPI(contractId).then((res) => {
      if (cancelled) return;
      const list = Array.isArray(res) ? res : res?.data || res?.clins || [];
      setClins(list.map(clinValue).filter((v) => v !== undefined && v !== null && v !== ""));
      setLoading(false);
    });
    return () => {
      cancelled = true;
    };
  }, [open, contractId]);

  const allSelected = clins.length > 0 && selected.length === clins.length;
  const options = [{ label: "All", value: ALL }, ...clins.map((c) => ({ label: String(c), value: c }))];
  const shownValue = allSelected ? [ALL, ...selected] : selected;

  const onChange = (vals) => {
    const hadAll = shownValue.includes(ALL);
    const hasAll = vals.includes(ALL);
    if (hasAll && !hadAll) setSelected(clins);
    else if (!hasAll && hadAll) setSelected([]);
    else setSelected(vals.filter((v) => v !== ALL));
  };

  if (!open) return null;
  return (
    <Dialog open={open} maxWidth="sm" fullWidth onClose={onClose}>
      <DialogContent style={{ padding: 20 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
          <span style={{ fontSize: 15, fontWeight: 600, color: "#111827" }}>Download PSR Trend</span>
          <span style={{ cursor: "pointer", fontSize: 18, lineHeight: 1 }} onClick={onClose}>×</span>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <Select
            mode="multiple"
            style={{ flex: 1, minWidth: 0 }}
            placeholder="Select CLIN"
            loading={loading}
            options={options}
            value={shownValue}
            onChange={onChange}
            maxTagCount="responsive"
            dropdownStyle={{ zIndex: 1500 }}
          />
          <button
            type="button"
            disabled={selected.length === 0}
            onClick={() => onDownload(allSelected ? [] : selected)}
            style={{
              height: 32,
              padding: "0 18px",
              border: "none",
              borderRadius: 4,
              color: "#fff",
              background: selected.length === 0 ? "#ccc" : BLUE,
              cursor: selected.length === 0 ? "not-allowed" : "pointer",
              fontWeight: 600,
            }}
          >
            Download
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
